var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable, computed } from "mobx";
import { EventsManager } from "sb-js-extends";
export var DeviceType;
(function (DeviceType) {
    DeviceType["desktop"] = "IsDesktop";
    DeviceType["mobile"] = "IsMobile";
    DeviceType["tablet"] = "IsTablet";
})(DeviceType || (DeviceType = {}));
export var DeviceOrientation;
(function (DeviceOrientation) {
    DeviceOrientation["landscape"] = "landscape-orientation";
    DeviceOrientation["portrait"] = "portrait-orientation";
    DeviceOrientation["desktop"] = "desktop-orientation";
})(DeviceOrientation || (DeviceOrientation = {}));
export class DeviceDetect {
    constructor() {
        if (!DeviceDetect._instance) {
            DeviceDetect._instance = this;
        }
        this.eventsManager = new EventsManager();
        this.deviceOrientation = DeviceOrientation.portrait;
        this.deviceType = DeviceType.mobile;
        const app = window["Application"];
        // tslint:disable-next-line
        if (typeof app !== "undefined" && typeof app.deviceType !== "undefined" && typeof app.deviceType.type !== "undefined") {
            this.deviceType = app.deviceType.type;
        }
        // tslint:disable-next-line
        if (typeof app !== "undefined" && typeof app.deviceOrientation !== "undefined" && typeof app.deviceOrientation.orientation !== "undefined") {
            this.deviceOrientation = app.deviceOrientation.orientation;
        }
        this.eventsManager.addEventListener("onDeviceOrientationChange", this, this.onDeviceOrientationChange, true);
        this.eventsManager.addEventListener("onDeviceTypeChange", this, this.onDeviceTypeChange, true);
        this.isIOS = false;
        this.checkIOS();
    }
    static getInstance() {
        return DeviceDetect._instance || new DeviceDetect();
    }
    get isDesktop() {
        return this.deviceType === DeviceType.desktop;
    }
    get isMobile() {
        return this.deviceType === DeviceType.mobile;
    }
    get isTablet() {
        return this.deviceType === DeviceType.tablet;
    }
    get isLandscape() {
        return this.deviceOrientation === DeviceOrientation.landscape;
    }
    get isPortrait() {
        return this.deviceOrientation === DeviceOrientation.portrait;
    }
    get deviceTypeValue() {
        return this.deviceType;
    }
    onDeviceOrientationChange(orientation) {
        this.deviceOrientation = orientation;
    }
    onDeviceTypeChange(type) {
        this.deviceType = type;
    }
    checkIOS() {
        this.isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) ? true : false;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], DeviceDetect.prototype, "deviceOrientation", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], DeviceDetect.prototype, "deviceType", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "isDesktop", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "isMobile", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "isTablet", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "isLandscape", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "isPortrait", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DeviceDetect.prototype, "deviceTypeValue", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DeviceDetect.prototype, "onDeviceOrientationChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DeviceDetect.prototype, "onDeviceTypeChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DeviceDetect.prototype, "checkIOS", null);
//# sourceMappingURL=DeviceDetect.js.map